import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n"]);
  _templateObject4 = function _templateObject4() {
    return data;
  };
  return data;
}
function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  .hzero-no-ued-wrapper {\n    height: 100%;\n    overflow: auto;\n  }\n  body {\n    .action-link > * {\n      vertical-align: middle;\n    }\n    .c7n-form-line-with-btn {\n      display: flex;\n      flex-direction: row;\n      padding-bottom: 8px;\n      align-items: flex-end;\n      .c7n-form-btn {\n        display: flex;\n        align-items: flex-end;\n        padding-bottom: 8px;\n      }\n      .c7n-pro-form {\n        padding-right: 8px;\n        .c7n-pro-field-wrapper {\n          padding-bottom: 0;\n        }\n      }\n    }\n    .form-btn-expand {\n      display: flex;\n      flex-flow: row nowrap;\n      button {\n        flex: 1;\n      }\n    }\n    .c7n-form-float-row {\n      display: flex;\n      flex-flow: row nowrap;\n      align-items: flex-start;\n    }\n  }\n\n  .c7n-modal-wrap {\n    ", "\n    .c7n-modal-sidebar {\n      text-align: left;\n    }\n    && .c7n-modal:not(.c7n-modal-sidebar) {\n      ", "\n    }\n  }\n"]);
  _templateObject3 = function _templateObject3() {
    return data;
  };
  return data;
}
function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  position: static;\n  display: inline-block;\n  vertical-align: middle;\n  text-align: left;\n"]);
  _templateObject2 = function _templateObject2() {
    return data;
  };
  return data;
}
function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  text-align: center;\n  &&:before {\n    content: '';\n    display: inline-block;\n    width: 0;\n    height: 100%;\n    vertical-align: middle;\n  }\n"]);
  _templateObject = function _templateObject() {
    return data;
  };
  return data;
}

/**
 * 全局样式，作用于所有主题
 */
import { createGlobalStyle, css } from 'styled-components'; // 配置中心没有导入样式，这些在配置中心使用的组件的样式手动导入一下

import 'hzero-ui/lib/anchor/style';
import 'hzero-ui/lib/switch/style';
import 'hzero-ui/lib/slider/style';
var modalWrapCss = css(_templateObject());
var modalContentCss = css(_templateObject2());
var globalCss = css(_templateObject3(), modalWrapCss, modalContentCss);
export default createGlobalStyle(_templateObject4(), globalCss);